import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const InfoWrapper = styled.div`
  max-width: 50rem;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10rem;
  margin-top: 2rem;
  gap: 1.2rem;

  button:nth-child(1) {
    width: 100%;
  }

  button:nth-child(2) {
    flex-grow: 1;
  }

  button:nth-child(3) {
    float: right;
    flex-grow: 1;
  }

  ${mediaQuery('md')} {
    display: flex;
    flex-wrap: nowrap;
    gap: 2.5rem;
    margin-bottom: 25rem;

    button:nth-child(1),
    button:nth-child(2) {
      min-width: 16.813rem;
      width: auto;
      flex-grow: unset;
    }

    button:nth-child(3) {
      min-width: 10rem;
      width: auto;
      flex-grow: unset;
    }
  }
`;
